module.exports = __webpack_public_path__ + "static/media/Balzam_na_rty_CBD_retina.a3d5db99.jpg";